<template>
  <div class="home-box">
    <Breadcrumbs :title="pageTitle"></Breadcrumbs>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <GLAccountsTable></GLAccountsTable>
      </div>
    </v-row>
  </div>
</template>

<script>
import GLAccountsTable from "@/components/GlAccounts/GLAccountsTable";
import Breadcrumbs from "@/components/shared/Breadcrumbs";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "GLAccountsList",
  components: {
    Breadcrumbs,
    GLAccountsTable,
  },

  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      pageTitle: "Manage GL Accounts",
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },

  methods: {},

  watch: {},
};
</script>
